package one.healthium.insights.ui.insights.models

data class SpaceUiModel(
    val valueDp: Int,
)
